import WebApp from '@twa-dev/sdk';

import { type InitialState } from '@/app/scripts/init-application/types';

import {} from '@/shared/store/app-store/types';

import { getDeviceInfo } from '../../../helpers/environment/get-device-info';
import { LIB_NAME, ServiceLogger } from '../service-logger';

import packg from '../../../../../package.json';

export const createServiceLoggerService = (initialState: InitialState) => {
  const { startAppArgs } = initialState.tg;
  const { lang } = initialState.app;

  const telegram_id = WebApp?.initDataUnsafe?.user?.id ?? startAppArgs?.telegram_id;
  const deviceInfo = getDeviceInfo(WebApp?.platform ?? {});

  const options = {
    d_mod: deviceInfo.device_model,
    d_os: deviceInfo.device_os,
    d_p: deviceInfo.device_platform,
    loc: lang,
    tg_id: String(telegram_id),
    lib_n: LIB_NAME,
    lib_v: packg.version,
  };

  const service = new ServiceLogger(options);
  return service;
};
